import { createSlotRecipe } from './runtime.js';

const avatarGroupConfig = {"name":"avatarGroup","className":"avatar-group","slots":["root"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md","sm"]}}

export const avatarGroup = /* @__PURE__ */ createSlotRecipe(avatarGroupConfig)